import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** `pad` = uniform padding (charts, forms). `flush` = header + edge-to-edge body (tables). */
  layout?: 'pad' | 'flush';
}

export function Card({ layout = 'pad', className, children, ...rest }: CardProps) {
  return (
    <section className={['ui-card', `ui-card--${layout}`, className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </section>
  );
}

interface CardHeaderProps {
  title: ReactNode;
  caption?: ReactNode;
  right?: ReactNode;
}

/** Sentence-case title, optional caption, optional right-side control. */
export function CardHeader({ title, caption, right }: CardHeaderProps) {
  return (
    <div className="ui-card-header">
      <div>
        <h3 className="ui-card-title">{title}</h3>
        {caption && <p className="ui-card-caption">{caption}</p>}
      </div>
      {right && <div className="ui-card-header-right">{right}</div>}
    </div>
  );
}

export function CardBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={['ui-card-body', className].filter(Boolean).join(' ')}>{children}</div>;
}
